import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { getTicketTypesWithNestedTickets } from 'common/entities/ticketType/selectors';

import { getLimitOneOrderPerEmail } from '../../../selectors';

import TicketTypeView from './TicketTypeView';
import TicketEmail from './TicketEmail';

const TicketTypeViewWithNested = ({ ticketType }) => (
    <React.Fragment>
        <TicketTypeView {...ticketType} />
        {(ticketType.nestedTicketTypes || []).map((nestedTicketType) => (
            <TicketTypeViewWithNested key={nestedTicketType.id} ticketType={nestedTicketType} />
        ))}
    </React.Fragment>
);

TicketTypeViewWithNested.propTypes = {
    ticketType: PropTypes.object.isRequired,
};

const TicketSelectionNode = (props) => (
    <React.Fragment>
        {(props.ticketTypes || []).map((ticketType) => (
            <TicketTypeViewWithNested key={ticketType.id} ticketType={ticketType} />
        ))}
        {props.limitOneOrderPerEmail && <TicketEmail />}
    </React.Fragment>
);

TicketSelectionNode.propTypes = {
    ticketTypes: PropTypes.array.isRequired,
    limitOneOrderPerEmail: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
    ticketTypes: getTicketTypesWithNestedTickets(state),
    limitOneOrderPerEmail: getLimitOneOrderPerEmail(state),
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(TicketSelectionNode);
